import { Reducer } from 'redux'

export interface Section {
  id: string
  createdAt: string
  updatedAt: string | null
  name: string
  displayOrder: number
  assessmentTypeId: string
  metaData: Record<string, { status: string }>
  status?: string
  sectionPillarId?: string
}

export interface SectionsState {
  sections: Section[]
  totalSectionsCount?: number
  selectedSectionId?: string
  selectedSection?: Section
}

export const initialState: SectionsState = {
  sections: [],
  selectedSectionId: undefined,
  selectedSection: {} as Section,
  totalSectionsCount: 0,
}

export enum SectionsActionTypes {
  SET_SECTIONS = 'SET_SECTIONS',
  SET_SELECTED_SECTION = 'SET_SELECTED_SECTION',
  SET_SELECTED_SECTION_ID = 'SET_SELECTED_SECTION_ID',
  CLEAR_SECTIONS = 'CLEAR_SECTIONS',
  SET_ERROR = 'SET_ERROR',
}

type actionType =
  | {
      type: SectionsActionTypes.SET_SECTIONS
      payload: SectionsState
    }
  | {
      type: SectionsActionTypes.SET_SELECTED_SECTION_ID
      payload: string
    }
  | {
      type: SectionsActionTypes.SET_SELECTED_SECTION
      payload: Section
    }
  | {
      type: SectionsActionTypes.CLEAR_SECTIONS
    }
  | {
      type: SectionsActionTypes.SET_ERROR
      payload: string
    }

export const reducer: Reducer<SectionsState, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SectionsActionTypes.SET_ERROR: {
      return {
        ...state,
        error: action.payload,
      }
    }
    case SectionsActionTypes.SET_SECTIONS: {
      return {
        ...state,
        sections: action.payload.sections,
        totalSectionsCount: action.payload.totalSectionsCount,
      }
    }
    case SectionsActionTypes.SET_SELECTED_SECTION_ID: {
      return {
        ...state,
        selectedSectionId: action.payload,
      }
    }
    case SectionsActionTypes.SET_SELECTED_SECTION: {
      return {
        ...state,
        selectedSection: action.payload,
      }
    }
    case SectionsActionTypes.CLEAR_SECTIONS: {
      return {
        ...state,
        sections: [],
        selectedSectionId: undefined,
        selectedSection: {} as Section,
        totalSectionsCount: 0,
      }
    }
    default: {
      return state
    }
  }
}
